import type { EntityState, Reducer } from "@reduxjs/toolkit"

import {
  createAction,
  createSlice,
  isAsyncThunkAction,
} from "@reduxjs/toolkit"

import type { AnyRequestName } from "../base/send-request"
import type { TrackedRequest } from "./models"
import type { RootState } from "./root.reducer"

import { isTruthyString } from "../base/type-guards"
import * as Models from "./models"
import { useRootSelector } from "./useRootSelector"

const initialState: EntityState<TrackedRequest, string> & { count: number } = {
  count: 0,
  entities: {} as Record<string, TrackedRequest>,
  ids: [],
}

const adapter = Models.requests.adapter

export const clearRequests = createAction("CLEAR_REQUEST")

// export const clearFetchStatus =
//   createAction<Array<AnyRequestName | TrackedRequest>>("ClearFetchStatus")

function extractRequestNameFromAction(action: { type?: string }) {
  const [requestName] = action.type?.split("/") ?? []

  if (isTruthyString(requestName)) {
    return requestName as AnyRequestName
  }
  return undefined
}
const slice = createSlice({
  extraReducers: (builder) =>
    builder
      .addCase(clearRequests, () => ({ ...initialState }))
      // .addMatcher(is)
      .addMatcher(isAsyncThunkAction, (state, action) => {
        const id = extractRequestNameFromAction(action)
        if (id) {
          adapter.upsertOne(state, {
            fetchStatus: action.meta.requestStatus,
            id,
          })
        }
      }),
  initialState,
  name: "requests",
  reducers: {},
})

const requests: Reducer<typeof initialState> = slice.reducer
export default requests

export function getFetchStatusByName(state: RootState, id: AnyRequestName) {
  return Models.requests.selectById(state, id)?.fetchStatus
}
/**
 *
 * @param state root state
 * @param id name of the request
 */
export function getIsPendingByRequestNameFromState(
  state: RootState,
  id: AnyRequestName,
) {
  return getFetchStatusByName(state, id) === "pending"
}

export function useIsPending(...requestNames: AnyRequestName[]): boolean {
  return useRootSelector((state) => {
    return requestNames.some((requestName) =>
      getIsPendingByRequestNameFromState(state, requestName),
    )
  })
}

export function getLoadActiveUserFetchStatusFromState(state: RootState) {
  return getFetchStatusByName(state, "LoadActiveUser")
}
export function getIsActiveUserLoadedFromState(state: RootState) {
  return getLoadActiveUserFetchStatusFromState(state) === "fulfilled"
}
